import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

import { IPublicationCustomCssDialogsMessages } from '../../../../../types';

import { styles } from './ApplyCustomCssDialog.styles';

export type IApplyCustomCssDialogProps = {
  messages: IPublicationCustomCssDialogsMessages;
  onApply(): void;
  onCancel(): void;
};

export const ApplyCustomCssDialog: React.FC<IApplyCustomCssDialogProps> = (props) => {
  const { messages, onCancel, onApply } = props;
  return (
    <Dialog
      open={true}
      onClose={onCancel}
      data-test="apply-custom-css-dialog"
      aria-labelledby="apply-custom-css-dialog-title"
    >
      <DialogTitle id="apply-custom-css-dialog-title" sx={styles.dialogTitle}>
        {messages.applyStyling}
        <IconButton aria-label="close" onClick={onCancel} size="small" sx={styles.closeButton}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">{messages.applyStylingDescription}</Typography>
        <br />
        <Typography variant="body2">
          <Typography component="span" variant="body2" fontWeight="bold">
            {messages.note}
          </Typography>
          {messages.applyStylingNote}
        </Typography>
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button
          variant="outlined" size="small"
          color="secondary"
          onClick={onCancel}
          data-test="custom-css-apply-cancel"
        >
          {messages.cancel}
        </Button>
        <Button
          variant="contained" size="small"
          color="primary"
          onClick={onApply}
          data-test="apply-styling"
        >
          {messages.apply}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
